const root = '/team';
const baseRoute = (path = '') => `${root}${path}`;

export default {
  root,
  create: baseRoute('/create'),
  invite: baseRoute('/invite'),
} as const;
